export default "__VITE_ASSET__c3465528__"